module.exports = __webpack_public_path__ + "static/img/fraud_2.1e084961.png";